export var InsistenceIntent;
(function (InsistenceIntent) {
    /** Prospecting insistence to see if coverage is possible */
    InsistenceIntent["Information"] = "information";
    /** Actual insistence for a new credit limit */
    InsistenceIntent["CreditLimit"] = "credit-limit";
})(InsistenceIntent || (InsistenceIntent = {}));
